const setMyCard = (state, payload) => {
    state.card = payload;
};
const setMyCardList = (state, payload) => {
    state.card_list = payload;
};
export default {
    setMyCard,
    setMyCardList,
};